import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'
import type { AthleticsAthleteProfile } from '@/types/enrollments'

// GET /ajax/athletics/{enrollmentId}/athlete (DTA-799 round 9): this
// family's own student on the team — jersey number, positions, captain and
// the roster status when the team runs tryout acceptance.
export const athleticsAthlete = async (enrollmentId: number): Promise<AthleticsAthleteProfile> => {
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).get(
    '/ajax/athletics/' + enrollmentId + '/athlete'
  )
  const data = response.data ?? {}
  return Util.Obj.keysToCamel({
    schema_version: data.schema_version ?? 1,
    athlete: { ...(data.athlete ?? {}), positions: data.athlete?.positions ?? [] },
    vocabulary: data.vocabulary ?? null
  }) as AthleticsAthleteProfile
}
